<div class="order-2 mt-xl md:order-1 md:col-span-6 md:mt-0 lg:col-span-7">
  <div #staticFormContainer></div>
</div>
@if (priceRange$ | async; as priceRange) {
  @if ({layout: layout$ | async}; as ctx) {
    <div class="sticky top-18 order-1 md:static md:order-2 md:col-span-6 lg:top-0 lg:col-span-5" *transloco="let t">
      <cft-client-price-range-card
        [offering]="offering"
        [priceRange]="priceRange"
        [showBreakdown]="ctx.layout?.showBreakdown || false"
        [infoText]="ctx.layout?.infoText || t('createJobRequest.priceRange.priceRangeEstimationHint')"
        [numberOfItems]="ctx.layout?.numberOfItems"
        class="rounded-3 bg-white px-lg py-lg shadow-1 md:sticky md:top-64 md:py-xl md:shadow-3"
      ></cft-client-price-range-card>
    </div>
  }
}
